import {
  Button,
  Icon,
  PhoneMockup,
  PhoneMockupBodyLayout,
  PhoneMockupLayout,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';
import { getIdFromUrl } from '@frontend/utils';
import { useEffect } from 'react';

import { ReactComponent as ArrowCornerCcwLtSvg } from '@frontend/icons/arrow-corner-ccw-lt.svg';
import { ReactComponent as Comment2QuestionSvg } from '@frontend/icons/comment-2-question.svg';

import links from '../../constants/links';
import { useWidgetContext } from '../../context/WidgetContext';

import { PageFields_CancelledPage_Fragment as PaymentCanceledPageFields } from '../../graphql/generated';
import { useRegisterHotjarPage } from '../../hooks';

export interface PaymentCanceledByUserProps {
  data: PaymentCanceledPageFields['cancelledPageData'];
}

const PaymentCanceledByUser = (props: PaymentCanceledByUserProps) => {
  const { configureHeader } = useWidgetContext();
  useRegisterHotjarPage('payment-canceled-by-user');

  useEffect(() => {
    configureHeader({
      id: getIdFromUrl(),
      merchantName: props.data?.merchantName || '',
    });
  }, []);

  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <WidgetHeader color="error">
            <WidgetHeaderContent title="Error" />
          </WidgetHeader>
        }
      >
        <PhoneMockupBodyLayout
          bodyCentered
          body={
            <WidgetStatus
              emoji="😔"
              title="You canceled the payment"
              data-test-id="canceledPaymentText"
              description={
                <>
                  If you think something is wrong please contact us. <br />
                  Payment ID: {getIdFromUrl()}
                </>
              }
            />
          }
          footer={
            <>
              <Button
                as="a"
                href={links.support.HOME}
                target="_blank"
                rel="noopener noreferrer"
                mt="24"
                size="large"
                variant="primary-outline"
                fullWidth
                data-test-id="contactSupport"
                rightIcon={<Icon component={<Comment2QuestionSvg />} />}
              >
                contact support
              </Button>
              {props.data?.cancelUrl && (
                <Button
                  as="a"
                  href={props.data.cancelUrl}
                  mt="16"
                  size="large"
                  variant="secondary"
                  rightIcon={<Icon component={<ArrowCornerCcwLtSvg />} />}
                >
                  Go back to store
                </Button>
              )}
            </>
          }
        />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
};

export default PaymentCanceledByUser;
